import React from "react";

export const Link = ({
  url = null,
  target = null,
  alt = null,
  rel = null,
  children,
  onClick = () => null,
  ariaLabel = "",
  title = null,
}) => {
  return (
    <a
      href={url}
      target={target}
      rel={rel}
      onClick={onClick}
      {...(ariaLabel && { "aria-label": ariaLabel })}
      {...(title && { title })}
    >
      {children}
    </a>
  );
};
